import "./Footer.css"

const Footer = () => {
  return (
    <div className="footer">
      <div className="fLists">
        <ul className="fList">
          <li className="fListItem">Pays</li>
          <li className="fListItem">Régions</li>
          <li className="fListItem">Villes</li>
          <li className="fListItem">Quartiers</li>
          <li className="fListItem">Aéroports</li>
        <li className="fListItem">Hôtels</li>
        <li className="fListItem">Sites d'intérêt </li>
                  
        </ul>
        <ul className="fList">
          <li className="fListItem">Hébergements indépendant </li>
          <li className="fListItem">Appartements</li>
          <li className="fListItem">Complexes hôteliers </li>
          <li className="fListItem">Villas</li>
          <li className="fListItem">Auberges de jeunesse</li>
        <li className="fListItem">B&B / Chambres d'hôtes</li>
        <li className="fListItem">Maisons d'hôtes</li>
        </ul>
        <ul className="fList">
                  <li className="fListItem">Des hébergements uniques </li>
                  <li className="fListItem">Toutes les destinations</li>
                  <li className="fListItem">Commentaires</li>
                    <li className="fListItem">Découvrir</li>
                    <li className="fListItem">Articles </li>
                    <li className="fListItem">Communautés de voyageurs </li>
                    <li className="fListItem">Offres de voyage saisonnières</li>
        </ul>
        <ul className="fList">
          <li className="fListItem">Location de voitures</li>
          <li className="fListItem">Comparateur de vols</li>
          <li className="fListItem">Réservations de restaurant </li>
          <li className="fListItem">Booking.com pour les Agents de Voyage</li>
        </ul>
        <ul className="fList">
                  <li className="fListItem">FAQ sur le coronavirus (COVID-19)</li>
                  <li className="fListItem">À propos de Booking.com</li>
                  <li className="fListItem">Aide du Service Clients</li>
                  
                    <li className="fListItem">Aide aux partenaires</li>
                    <li className="fListItem">Careers</li>
                    <li className="fListItem">Durabilité</li>
                    <li className="fListItem">Actualités presse</li>
                    <li className="fListItem">Centre des ressources en matière de sécurité</li>
                    <li className="fListItem">Relations avec les investisseurs</li>
                  <li className="fListItem">Conditions Générales d'Utilisation</li>
                  <li className="fListItem">Réclamation partenaires</li>
                  <li className="fListItem">Le fonctionnement de notre site</li>
                  <li className="fListItem">Charte de confidentialité et informations sur les cookies</li>
                  <li className="fListItem">Contacts de l'entreprise</li>
        </ul>
      </div>
      <div className="fText">Copyright © 1996–2022 Tous droits réservés © Copyright © ROYAL HOTEL Booking.com.</div>
    </div>
  )
}

export default Footer










